module.exports = __webpack_public_path__ + "static/media/Tapu Bulu_gaussian2.66bd19c4.png";